import type { Component } from '@wix/thunderbolt-becky-types'
import { createCssCompNode } from '../cssCompNode'
import type { CompInfo, NativeExtensions } from '@wix/thunderbolt-components-native'
import { compInfoNodes } from '@wix/thunderbolt-component-isolation'
import { mapValues } from '../../utils/mapValues'
import type { NodeRefs } from '@wix/thunderbolt-catharsis'
import _ from 'lodash'

const reduce = <TObj extends Record<string, any>, TResult>(
	obj: TObj,
	fn: (acc: TResult, value: TObj[keyof TObj], key: keyof TObj) => TResult,
	acc: TResult
) => {
	return _.reduce(obj, fn, acc)
}

export const uiTypeCompNode = ({ extensions }: NativeExtensions) => {
	const carmiData = undefined as never
	return createCssCompNode('compCssMappers', 'uiType', {
		getDependencies: (component: Component, refs) => {
			const extension = extensions[component.componentType]
			if (!extension) {
				return null
			}

			return reduce(
				extension.deps,
				(acc, __, dep) => {
					const dependencies = compInfoNodes[dep].getDependencies(component, refs as NodeRefs<any>)
					if (dependencies) {
						// @ts-ignore
						acc[dep] = dependencies
					}

					return acc
				},
				{}
			)
		},
		toViewItem: (component, data: any) => {
			if (!data) {
				return null
			}

			const extension = extensions[component.componentType]
			const compInfo = mapValues(extension.deps, (__, dep) => {
				// Change type to never because typescript is not able to infer the type of compInfoNodes[dep].toViewItem
				return compInfoNodes[dep].toViewItem(component, data[dep])
			}) as CompInfo

			// uiType resolver return as string but there is no type for it
			return (extension.resolver(compInfo, carmiData) as any) as string
		},
	})
}
